import request from '@/config/axios'

export interface LiveAnchorVO {
  id?: number
  userId: number
  nickname?: string
  /** 性别：0未知 1男 2女 */
  sex?: number
  realName: string
  idCard?: string
  idCardFront?: string
  idCardBack?: string
  phone?: string
  email?: string
  intro?: string
  avatar?: string
  status?: number
  auditRemark?: string
  sort?: number
  createTime?: string
}

export const pageAnchor = (params: any) => request.get({ url: '/live/anchor/page', params })
export const getAnchor = (id: number) => request.get({ url: '/live/anchor/get', params: { id } })
export const createAnchor = (data: LiveAnchorVO) =>
  request.post({ url: '/live/anchor/create', data })
export const updateAnchor = (data: LiveAnchorVO) =>
  request.put({ url: '/live/anchor/update', data })
export const deleteAnchor = (id: number) =>
  request.delete({ url: '/live/anchor/delete', params: { id } })
export const auditAnchor = (id: number, status: number, auditRemark?: string) =>
  request.post({ url: '/live/anchor/audit', params: { id, status, auditRemark } })

/** 开关主播直播权限（通过↔禁用），对齐 PHP live_open */
export const setLivePermission = (userId: number, allow: boolean) =>
  request.post({ url: '/live/anchor/set-live-permission', params: { userId, allow } })
